/**
 * App — composición raíz del front.
 * Capas: ErrorBoundary (global) → AppProviders (Query+Toast+Auth) → AppRouter (TODAS las rutas).
 * Layouts anidados viven en `src/app/layouts/`.
 *
 * F2 cerró el design system. F3 (este archivo) cablea router + providers + boundary.
 * F4 reescribe páginas reales. F5/F6 añaden guards de auth/rol.
 */
import { ErrorBoundary } from './app/error-boundary';
import { AppProviders } from './app/providers';
import { AppRouter } from './app/router';

function App() {
  return (
    <ErrorBoundary>
      <AppProviders>
        <AppRouter />
      </AppProviders>
    </ErrorBoundary>
  );
}

export default App;
